<template>
  <div class="quizbet-wrapper">
    <div v-if="loading" class="loading-state">
      <div class="spinner"></div>
    </div>

    <div v-else-if="errorMsg" class="error-state">
      <span>{{ errorMsg }}</span>
      <button class="nav-btn btn-outline" @click="fetchApiData">Riprova</button>
    </div>

    <div v-else-if="quizItems.length > 0" class="quizbet-container">

<!--      <div class="qb-header">-->
<!--        <svg  width="28" height="28" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"  style="fill: currentcolor; color: var(&#45;&#45;color-primary-light);">-->

<!--          <path d="M1.5 10C1.5 13.5 4.5 15.5 8 15.5C11.5 15.5 14 14 15 12C13.5 13.5 11 14 8 14C5 14 3 12.5 3 10C3 8.5 3.5 7.5 4.5 6.5C3 7.5 1.5 8.5 1.5 10Z"></path>-->

<!--          <path d="M5 6A3 3 0 0 1 11 6C11 8 9 8.5 9 10H7C7 7.5 9 7.5 9 6A1 1 0 0 0 7 6H5Z"></path>-->

<!--          <path d="M8 10.5C8 11.8 8.8 12.5 10 12.5C8.8 12.5 8 13.2 8 14.5C8 13.2 7.2 12.5 6 12.5C7.2 12.5 8 11.8 8 10.5Z"></path>-->

<!--          <path d="M13 2C13 2.8 13.5 3.2 14.5 3.2C13.5 3.2 13 3.6 13 4.4C13 3.6 12.5 3.2 11.5 3.2C12.5 3.2 13 2.8 13 2Z"></path>-->

<!--        </svg>-->

<!--        <span class="qb-header-title">QUIZBET</span>-->
<!--      </div>-->

      <transition name="slide-fade" mode="out-in">

        <div v-if="!isCompleted" :key="currentIndex" class="quiz-card" :style="styleMatchHero(currentItem.sportId || '6046')">

          <div class="qb-content">
            <div class="qb-meta">
              <span v-if="currentItem.tournamentName">{{ currentItem.tournamentName }} </span>
            </div>

            <div class="qb-teams">
              <div class="qb-team-col">
                <LogoCompetitors :team-id="currentItem.homeId" height="52px" width="52px"/>
                <span class="qb-team-name">{{ currentItem.homeName }}</span>
              </div>

              <div class="qb-vs-wrapper">
                <span class="qb-vs-text">VS</span>
              </div>

              <div class="qb-team-col">
                <LogoCompetitors :team-id="currentItem.awayId" height="52px" width="52px"/>
                <span class="qb-team-name">{{ currentItem.awayName }}</span>
              </div>
            </div>

            <div class="qb-question">
              {{ currentItem.question }}
            </div>

            <div class="qb-outcomes-row" :style="{ display: 'grid', gridTemplateColumns: `repeat(${currentItem.outcomes && currentItem.outcomes.length >= 3 ? 3 : 2}, 1fr)`, gap: '8px' }">
              <div
                  v-for="outcome in currentItem.outcomes"
                  :key="outcome.unique_id"
                  class="qb-outcome-btn"
                  :class="{ 'qb-selected': isSelected(outcome.unique_id) }"
                  @click="selectOutcomeAndNext(outcome)"
              >
                <span class="qb-out-name">{{ getOutcomeName(currentItem.competitors, outcome) }}</span>
              </div>
            </div>

            <div class="qb-dots-container">
              <span
                  v-for="(item, i) in quizItems"
                  :key="i"
                  class="qb-dot"
                  :class="{
                      'qb-dot--active': i === currentIndex,
                      'qb-dot--done': selections[item.matchId] !== undefined
                  }"
                  @click="goToIndex(i, item)"
              ></span>
            </div>
          </div>
        </div>

        <div v-else key="recap" class="quiz-card recap-card">
          <h2 class="recap-title">{{ $t('quizbet_completed') || 'Quiz completato!' }}</h2>

          <div class="selections-list">
            <div v-for="(item, index) in quizItems" :key="index" class="recap-item">
              <div class="recap-teams">
                <div class="recap-team-row">
                  <LogoCompetitors :team-id="item.homeId" height="16px" width="16px"/>
                  <span>{{ item.homeName }}</span>
                </div>
                <div class="recap-team-row">
                  <LogoCompetitors :team-id="item.awayId" height="16px" width="16px"/>
                  <span>{{ item.awayName }}</span>
                </div>
              </div>
              <div class="recap-choice">
                <span class="recap-market">{{ item.marketName }}</span>
                <div class="recap-selection-wrap">
                  <span class="recap-selection">{{ getOutcomeName(item.competitors, getSelectedOutcome(item.matchId)) }}</span>
                  <span v-if="getOutcomeSpecifier(item)" class="recap-specifier">{{ getOutcomeSpecifier(item) }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="recap-footer">
            <div class="action-buttons">
              <button class="nav-btn btn-reset" @click="resetQuiz" :title="$t('delete') || 'Ricomincia'">
                <v-icon size="16" color="currentColor">mdi-delete-outline</v-icon>
              </button>
              <button class="nav-btn btn-primary" @click="addToCart">{{ $t('addToCart') || 'Aggiungi al Carrello' }}</button>
            </div>
          </div>
        </div>

      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LogoCompetitors from '@/components/center_widgets/LogoCompetitors.vue';

export default {
  name: 'QuizBet',
  components: { LogoCompetitors },
  data() {
    return {
      loading: true,
      errorMsg: null,
      quizItems: [],
      currentIndex: 0,
      selections: {},
      isCompleted: false,
      sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons-color/',
    };
  },
  computed: {
    ...mapGetters({
      'getPreview': 'previewPrematch/getPreview',
      'getRawEvents': 'bestPlayed/getBestPlayedEvents'
    }),
    getGroupedEvents() {
      if (!this.getRawEvents || this.getRawEvents.length === 0) return [];
      return Object.values(this.getRawEvents[0].events).flatMap(item => item.events || []);
    },
    currentItem() {
      return this.quizItems[this.currentIndex] || {};
    },
    progressPercentage() {
      if (this.quizItems.length === 0) return 0;
      if (this.isCompleted) return 100;
      return (this.currentIndex / this.quizItems.length) * 100;
    },
    totalOdds() {
      const keys = Object.keys(this.selections);
      if (keys.length === 0) return '0.00';
      let total = 1;
      keys.forEach(key => {
        const v = parseFloat(this.selections[key].outcome_odd_value);
        if (!isNaN(v)) total *= v;
      });
      return total.toFixed(2);
    }
  },
  watch: {
    getRawEvents(newVal) {
      if (newVal) this.fetchApiData();
    }
  },
  mounted() {
    this.fetchApiData();
  },
  methods: {
    ...mapActions({
      addOddToCartV3: 'cart/addOddToCartV3'
    }),
    styleMatchHero(sportId){
      let urlBg = this.getSportBg(sportId);
      // Perfetta simulazione dello sfumato presente in foto, che parte scuro dall'alto
      // e svela l'immagine del campo solo nella parte inferiore.
      return {
        backgroundImage: `linear-gradient(to bottom, #101318 0%, #101318 45%, rgba(16,19,24,0.7) 70%, rgba(16,19,24,0) 100%), url(${urlBg})`,
        backgroundSize: '250% auto',
        backgroundPosition: 'bottom center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#101318'
      }
    },
    getSportBg(sportId) {
      return require('@/assets/images/pitch-football.png')
      // return `${process.env.VUE_APP_URL_CLOUDFRONT}/svg/quizbet/${sportId}.webp`;
    },
    handleImgError(e) { e.target.style.display = 'none'; },

    async fetchApiData() {
      this.loading = true;
      this.errorMsg = null;
      try {
        if (!this.getGroupedEvents) {
          this.errorMsg = 'Nessun evento disponibile.';
          return;
        }
        this.generateQuiz(this.getGroupedEvents);
      } catch (e) {
        this.errorMsg = 'Errore nel caricamento degli eventi.';
      } finally {
        this.loading = false;
      }
    },

    shuffleArray(array) {
      let cur = array.length, rnd;
      while (cur !== 0) {
        rnd = Math.floor(Math.random() * cur);
        cur--;
        [array[cur], array[rnd]] = [array[rnd], array[cur]];
      }
      return array;
    },

    generateQuiz(data) {
      let validMatches = data.filter(m =>  m.odds && m.odds.length > 0);
      validMatches = this.shuffleArray(validMatches);
      const selectedMatches = validMatches.slice(0, 6);

      const generatedItems = selectedMatches.map(match => {
        const validMarkets = match.odds.filter(market => {
          if (!market.outcome || !Array.isArray(market.outcome)) return false;
          if (market.id === '7') return false;
          return market.outcome.filter(o => String(o.status) === '1').length >= 2;
        });
        if (validMarkets.length === 0) return null;

        const selectedMarket = this.shuffleArray([...validMarkets])[0];
        const activeOutcomes = selectedMarket.outcome.filter(o =>
          String(o.status) === '1' &&
          o.outcome_name !== 'X' &&
          o.outcome_name?.toLowerCase() !== 'empate'
        );

        const dateObj = new Date(match.scheduled);
        const d = dateObj.getDate().toString().padStart(2, '0');
        const mo = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const h = dateObj.getHours().toString().padStart(2, '0');
        const mi = dateObj.getMinutes().toString().padStart(2, '0');

        return {
          matchId:        match.id,
          matchName:      match.eventName,
          competitors:    match.competitors || [],
          homeName:       match.home || (match.competitors?.[0]?.name ?? ''),
          awayName:       match.away || (match.competitors?.[1]?.name ?? ''),
          homeId:         match.home_id,
          awayId:         match.away_id,
          sportId:        match.sportId,
          tournamentName: match.tournamentName || match.categoryName || '',
          date:           `Oggi ${h}:${mi}`, // Formattato come in foto
          marketId:       selectedMarket.id,
          marketName:     selectedMarket.marketName,
          specifier:      selectedMarket.specifier || null,
          question:       this.formatQuestion(match.eventName, match.home, match.away, selectedMarket),
          outcomes:       activeOutcomes,
          rawEvent:       match,
          rawMarket:      selectedMarket
        };
      });

      this.quizItems = generatedItems.filter(Boolean);
    },

    formatQuestion(matchName, home, away,  market) {
      const mName = market.marketName.toLowerCase();
      const spec = market.specifier || '';

      if (mName.includes('1x2'))
        return this.$t('quizbet_question_1x2', { home, away }) || 'Chi vincerà?';
      if (mName.includes('under/over'))
        return this.$t('quizbet_question_overUnder', { spec }) || `Ci saranno più o meno di ${spec} gol?`;

      const specLabel = spec ? ` (${spec})` : '';
      return this.$t('quizbet_question_generic', { market: market.marketName, spec: specLabel }) || `Pronostico per ${market.marketName}${specLabel}?`;
    },

    getOutcomeName(competitors, outcome) {
      if (!outcome) return '';
      const outcomeName = outcome.outcome_name;
      if (!outcomeName) return outcome.name || '';
      const lower = outcomeName.toLowerCase();
      if (lower === 'local') return competitors?.[0]?.name || outcome.outcome_alias || outcomeName;
      if (lower === 'visitante') return competitors?.[1]?.name || outcome.outcome_alias || outcomeName;
      if (outcomeName === '1') {
        const c = competitors?.find(c => String(c.position) === '1');
        return c?.name || outcome.outcome_alias || outcomeName;
      }
      if (outcomeName === '2') {
        const c = competitors?.find(c => String(c.position) === '2');
        return c?.name || outcome.outcome_alias || outcomeName;
      }
      return outcome.outcome_alias || outcomeName || outcome.name || '';
    },

    isSelected(outcomeId) {
      const sel = this.selections[this.currentItem.matchId];
      return sel && sel.unique_id === outcomeId;
    },

    getSelectedOutcome(matchId) {
      return this.selections[matchId] || {};
    },

    getOutcomeSpecifier(item) {
      const outcome = this.getSelectedOutcome(item.matchId);
      return outcome.specifiers || outcome.specifier || outcome.line || outcome.baseLine || item.specifier || null;
    },

    selectOutcomeAndNext(outcome) {
      this.$set(this.selections, this.currentItem.matchId, outcome);
      setTimeout(() => {
        if (this.currentIndex < this.quizItems.length - 1) {
          this.currentIndex++;
        } else {
          this.isCompleted = true;
        }
      }, 300);
    },

    goToIndex(i, item) {
      if (this.selections[item.matchId] !== undefined) {
        this.currentIndex = i;
      }
    },

    resetQuiz() {
      this.quizItems = [];
      this.selections = {};
      this.currentIndex = 0;
      this.isCompleted = false;
      this.fetchApiData();
    },

    async addToCart() {
      for (const [matchId, outcome] of Object.entries(this.selections)) {
        const item = this.quizItems.find(q => q.matchId === matchId);
        if (!item || !item.rawEvent || !item.rawMarket) continue;
        const odd = { ...outcome, type: 'prematch' };
        await this.addOddToCartV3({
          oddMarket: item.rawMarket,
          odd,
          event:      item.rawEvent,
          sport:      { id: item.rawEvent.sportId },
          category:   { id: item.rawEvent.categoryId },
          tournament: { id: item.rawEvent.tournamentId, name: item.rawEvent.tournamentName },
        });
      }
      this.resetQuiz();
    }
  }
};
</script>

<style scoped>
/* ── Container Globale ── */
.quizbet-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100%;
}

.quizbet-container {
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

/* ── Header ── */
.qb-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px 8px 4px;
}

.qb-flash-icon {
  width: 16px;
  height: 16px;
}

.qb-header-title {
  font-size: var(--font-size-3xl);
  font-weight: 600;
  text-transform: uppercase;
}

/* ── Quiz Card (Sfondo interno) ── */
.quiz-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 320px; /* Altezza adatta per far vedere l'immagine in fondo */
  background-color: #101318;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  overflow: hidden;
}

.qb-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 20px 20px 20px;
  height: 100%;
  flex: 1;
}

/* ── Meta (Lega + Data) ── */
.qb-meta {
  font-size: var(--font-size-md);
  font-weight: 500;
  color: var(--text-op-50-platform);
  margin-bottom: 12px;
  text-align: center;
}

/* ── Squadre & Loghi ── */
.qb-teams {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 30px;
}

.qb-team-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}

.qb-team-col img {
  height: 52px;
  width: auto;
  object-fit: contain;
}

.qb-team-name {
  font-size: var(--font-size-2xl);
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
}

.qb-vs-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  padding: 0 16px;
}

.qb-vs-text {
  font-size: var(--font-size-4xl);
  font-weight: 800;
  color: #8C9098;
}

/* ── Domanda ── */
.qb-question {
  font-size: var(--font-size-3xl);
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 16px;
  text-align: center;
}

/* ── Bottoni Quote ── */
.qb-outcomes-row {
  width: 100%;
}

.qb-outcome-btn {
  width: 100%;
  min-width: 0;
  background-color: var(--bg-cell);
  border: 1px solid var(--color-primary-light);
  border-radius: 8px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
  overflow: hidden;
}

.qb-outcome-btn:hover {
  background-color: #2b303a;
}

.qb-out-name {
  font-size: var(--font-size-4xl);
  font-weight: 600;
  color: var(--color-primary-light);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}

.qb-out-odd {
  font-size: var(--font-size-4xl);
  font-weight: 700;
  color: #ffffff;
}

/* Stato Attivo (Selezionato) */
.qb-outcome-btn.qb-selected {
  background-color: var(--color-primary-light);
}
.qb-outcome-btn.qb-selected .qb-out-name,
.qb-outcome-btn.qb-selected .qb-out-odd {
  color: #000000;
}

/* ── Pallini Navigazione (Dots) ── */
.qb-dots-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: auto; /* Spinge i pallini in fondo alla card, sopra l'immagine */
}

.qb-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #464A53;
  cursor: pointer;
  transition: all 0.3s ease;
}

.qb-dot.qb-dot--active {
  background-color: #A4E4C3;
  transform: scale(1.3);
}

.qb-dot.qb-dot--done:not(.qb-dot--active) {
  background-color: #707070;
}

/* ── Recap Card (Adattata al nuovo tema scuro) ── */
.recap-card {
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #101318;
}

.recap-title {
  text-align: center;
  color: #1CD873;
  font-size: var(--font-size-6xl);
  font-weight: 800;
  margin: 0;
}

.selections-list {
  max-height: 280px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  scrollbar-width: thin;
}

.recap-item {
  border-bottom: 1px solid rgba(255,255,255,0.04);
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.recap-teams {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.recap-team-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-3xl);
  font-weight: 600;
  color: #ffffff;
}

.recap-team-row img{
  height: 40px;
  width: 40px;
}

.recap-choice {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-3xl);
}

.recap-market {
  color: var(--text-op-50-platform);
  flex: 1;
}

.recap-selection-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
}

.recap-selection {
  color: #ffffff;
  font-weight: 700;
}

.recap-specifier {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-xl);
  font-weight: 600;
}

.recap-odd {
  font-weight: 800;
  color: #1CD873;
}

.recap-footer {
  background: #20242D;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.total-odds {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-4xl);
  color: var(--text-op-50-platform);
}

.total-odds strong {
  color: #1CD873;
  font-size: var(--font-size-8xl);
  font-weight: 800;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.btn-primary, .btn-reset {
  padding: 12px 18px;
  border-radius: 8px;
  font-weight: 600;
  font-size: var(--font-size-4xl);
  cursor: pointer;
  border: none;
  transition: all 0.2s;
}

.btn-primary {
  flex: 1;
  background: #1CD873;
  color: #000;
  font-weight: 700;
}

.btn-primary:hover {
  opacity: 0.9;
}

.btn-reset {
  flex: 0 0 auto;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid rgba(255,255,255,0.1);
  color: var(--text-op-50-platform);
}

.btn-reset:hover {
  background: rgba(255, 59, 59, 0.15);
  border-color: rgba(255, 59, 59, 0.4);
  color: #ff4444;
}

/* ── Loading / Error ── */
.loading-state, .error-state {
  text-align: center;
  color: var(--text-op-50-platform);
  padding: 40px;
}

.spinner {
  border: 3px solid rgba(255,255,255,0.05);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-left-color: #1CD873;
  animation: spin 0.8s linear infinite;
  margin: 0 auto;
}

@keyframes spin { to { transform: rotate(360deg); } }

/* ── Transitions ── */
.slide-fade-enter-active { transition: all 0.35s ease; }
.slide-fade-leave-active { transition: all 0.25s ease; }
.slide-fade-enter { transform: translateX(24px); opacity: 0; }
.slide-fade-leave-to { transform: translateX(-24px); opacity: 0; }
</style>